export enum ERROR_PLACEHOLDERS {
  LOGIN_FIELDS_NOT_CORRECT = 'Email or password is not correct',
  EMAIL_FIELD_INVALID_FORMAT = 'Email should be in name@domain.com format',
}
